import { useLayoutEffect } from 'react';
import { useSelectableContext } from './SelectableProvider.js';

var useScrollActiveIntoView = function () {
    var _a = useSelectableContext(), activeOption = _a.activeOption, listRef = _a.listRef, scrollActiveIntoView = _a.scrollActiveIntoView;
    useLayoutEffect(function () {
        var _a;
        if (!scrollActiveIntoView)
            return;
        var active = (_a = listRef.current) === null || _a === void 0 ? void 0 : _a.querySelector("[data-active=true]");
        if (active) {
            active.scrollIntoView({ behavior: "smooth", block: "nearest" });
        }
    }, [activeOption]);
    return null;
};

export { useScrollActiveIntoView };
//# sourceMappingURL=useScrollActiveIntoView.js.map
